
import * as defaultImport from "@splunk/react-icons/Circle";
export * from "@splunk/react-icons/Circle";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
